import React, { FC } from "react";
import { Checkbox as CheckboxMUI } from "@mui/material";

import { CheckboxProps } from "./models";
import { LabelStyled } from "./styles";

const Checkbox: FC<CheckboxProps> = ({
  id,
  label,
  value,
  hasError,
  onChange,
}) => {
  return (
    <LabelStyled htmlFor={id} hasError={hasError}>
      <CheckboxMUI id={id} checked={value} onChange={onChange} />
      {label}
    </LabelStyled>
  );
};

export default Checkbox;
